import { Components, Theme } from '@mui/material/styles';

export const MuiTypography: Components<Theme>['MuiTypography'] = {
  defaultProps: {
    color: 'text.primary',
    variant: 'body1',
    variantMapping: {
      bigNumber: 'p',
      bodyLarge: 'p',
      caption: 'p',
    },
  },
};
